import React, {useState, useEffect} from 'react';
import './CharacteristicsPage.css'; 
import { Link } from 'react-router-dom';
import PointsUI from "./PointsUI/PointsUI";

const CharacteristicsPage = props => {

    const [textInfo, setTextInfo] = useState("");

    useEffect(() => {
        animateText("Choose the best pokemon based on his characteristics to win!");
    }, []);

    const animateText = (text) => {
        const splittedText = text.split(""); // ['b', 'o']
        let currentText = "";
        let index = 0;
        const anim = setInterval(() => {
            currentText += splittedText[index];
            setTextInfo(currentText);
            if (currentText.length === splittedText.length) {
                clearInterval(anim);
            } 
            index++;    
        }, 45);
    }

    return (
        <div className="CharacteristicsPage">
            <PointsUI points={props.playerPoints} />
            <div className="container">
                <div className="framePokemon">
                        <img src={`http://www.pokestadium.com/sprites/xy/${props.name}.gif`}/>
                        <div className="backgroundPokemon"></div>

                    <div className="namePokemon">{props.name}</div>
                </div>
                
                <div className="characteristics">
                    <h4>The characteristics of the pokemon</h4>
                    <ul>
                        <li>Type: {props.types.map(type => `${type.type.name} `)}</li>
                        <li>HT: {props.height}'</li>
                        <li>WT: {props.weight} b</li>
                        <li>No. {props.index}</li>
                    </ul>
                    <div className="Description-text">
                            {textInfo}
                    </div>
                     <Link to="/versus" className="buttonContainer1">Pick Me !</Link>
                </div>
                <Link to="/show-elements" className="buttonContainer2">Back</Link>
            </div> 

        </div>

    );
}

export default CharacteristicsPage;